const domReady: Promise<void> = new Promise(resolve => {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    resolve();
  } else {
    document.addEventListener("DOMContentLoaded", () => resolve());
  }
});
export default domReady;